import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
  background: theme.palette.background.paper,
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));
